<template>
  <transition name="fade" appear>
    <dialog
      v-show="isOpen"
      class="c-parts-message -info"
    >
      <p class="p-homework-line-break">{{ createDisplayedMessage(message) }}</p>
      <a
        href="javascript:void(0);"
        class="c-parts-message-close"
        @click="emit('close')"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="c-parts-message-close-icon">
          <path d="M11.9999 1.65661L10.3433 0L6 4.34327L1.65663 0L0 1.65684L4.3433 6.00014L0 10.3434L1.65675 12L6 7.65675L10.3433 12L11.9999 10.3434L7.65661 6.00014L11.9999 1.65661Z"/>
        </svg>
      </a>
    </dialog>
  </transition>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      isOpen?: boolean;
      message?: string;
    }>(),
    {
      isOpen: false,
      message: ""
    }
  )
  const emit = defineEmits<{
    (e: 'close'): void,
  }>()

  function createDisplayedMessage(message: string) {
    // 改行コードがAPIから渡せないため、メッセージの改行箇所に'<br>'を置いてこちらで改行コードに置き換えている
    return message.replace(/<br>/g, '\n')
  }
</script>

